module.exports = __webpack_public_path__ + "img/dynamicLogo5.d638bb96.png";